import { useContext, useState } from "react";
import { Loader, Logo, ViewContext } from "@/components/lib";
import { useForm } from "react-hook-form";
import axios from "axios";
import Styles from "@/css/mainStyles";

export function ForgotPassword() {
  const viewContext = useContext<any>(ViewContext);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({});

  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      await axios({
        method: "post",
        url: "/api/auth/password/reset/request",
        data
      });
      setSuccess(true);
      viewContext.notification.show("Password reset email sent", "success");
    } catch (error) {
      console.error(error);
      const message = error.response?.data?.message
        ? error.response.data.message
        : error.message;
      viewContext.notification.show(message, "error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex flex-col justify-center h-screen p-8 md:px-32 text-left lg:w-1/2">
      <Logo className="w-80 lg:w-96 mx-auto my-5 lg:mb-12" />
      <h1 className="font-bold text-2xl lg:text-4xl text-center">
        Reset Your Password
      </h1>
      <p className="my-2 text-center lg:text-xl">
        Enter your email address and we'll send you instructions to reset your
        password.
      </p>
      {success && (
        <p className="my-2 text-center lg:text-xl">Password reset email sent</p>
      )}
      <form
        className="flex flex-col items-center gap-6 mt-7"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>Email</label>
          <input
            placeholder="Enter Email"
            type="email"
            className={Styles.input}
            {...register("email", { required: true })}
            style={errors.email && { border: "1px solid red" }}
          />
        </div>
        <button
          type="submit"
          className={Styles.submitButton}
          disabled={loading || success}
        >
          Reset Password
          {loading && <Loader />}
        </button>
      </form>
    </div>
  );
}
